export const initialInfoByLegalEntity = {
  Name: undefined,
  LegalEntityId: undefined,
  PayType: undefined,
  Bank: undefined,
  Description: undefined,
  IsDefault: undefined,
};
